import { Page, Text, View } from '@react-pdf/renderer';
import { PdfHeader } from '../pdfHeader';
import { PdfChart } from './pdfChart';
import { PdfFooter } from '../pdfFooter';
import { ChartPageProps } from 'interfaces/components/dashboardPdf';
import { getPdfFilters } from 'utils/helpers/mapPdfInfo';
import Filter from './filter';

export const ChartPage = ({
  image,
  title,
  pagesCount,
  pageNumber,
  chartFilters,
  chartSwitches,
  disabledFilters
}: ChartPageProps) => {
  const filters = getPdfFilters(
    chartFilters,
    disabledFilters[title],
    chartSwitches
  );

  return (
    <Page
      size='A4'
      orientation='landscape'
      style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
    >
      <PdfHeader />

      <View
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          marginHorizontal: '20px',
          padding: '12px',
          borderRadius: '8px',
          border: '1px solid #F2F2F2'
        }}
      >
        <Text
          style={{ fontSize: '16px', fontWeight: 'semibold', color: '#151515' }}
        >
          Filters
        </Text>

        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'stretch',
            gap: '8px'
          }}
        >
          {filters.map((filter, index) => (
            <Filter key={filter.label} filter={filter} isFirst={index === 0} />
          ))}
        </View>
      </View>

      <PdfChart title={title} image={image} />

      <PdfFooter pageNumber={pageNumber} pagesCount={pagesCount} />
    </Page>
  );
};
